import { useEffect, useState } from 'react';
import axios from 'axios';

let cached = null;
let pending = null;

const seoSite = require('../seo/seoCore').site;

// Current business name: loaded Company Profile, else the one the server put in the page, else the built-in default.
export const brandName = () => {
  const b = cached || (typeof window !== 'undefined' && window.__SITE_BRAND__);
  return b ? b.brand_name || '' : seoSite.name;
};
export const assistantName = () => brandName().split(' ')[0] || 'Support';
export const useBrandName = () => { const b = useCompanyBrand(); return b ? b.brand_name || '' : brandName(); };

export const clearCompanyBrand = () => { cached = null; pending = null; };

// Public company details from Admin → Company Profile (brand name, logo, contact).
export const useCompanyBrand = () => {
  const [brand, setBrand] = useState(cached);
  useEffect(() => {
    if (cached) return;
    pending = pending || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/company-profile/public`).then((r) => { cached = r.data; return cached; });
    pending.then(setBrand).catch(() => { pending = null; });
  }, []);
  return brand;
};
